import React from "react";
import * as Components from "./components.jsx";

// Unified menu and route structure with components
export const MENU_STRUCTURE = [
  {
    key: 'dashboard',
    label: 'Beranda',
    path: '/beranda',
    icon: 'grid_view',
    component: Components.DashboardPage,
    routes: [
      { path: '/', label: 'Beranda', component: Components.DashboardPage },
    ]
  },
  {
    key: 'budgeting',
    label: 'Anggaran',
    icon: 'wallet',
    permissions: ["activity.view"],
    children: [
      {
        key: 'budget_activity',
        label: 'Anggaran Berbasis Aktivitas',
        path: '/anggaran/kegiatan',
        permissions: ['activity.view'],
        component: Components.BudgetActivity,
        subRoutes: [
          { path: '/anggaran/kegiatan/tambah', label: 'Tambah Anggaran Aktivitas', component: Components.AddBudgetActivity },
          { path: '/anggaran/kegiatan/edit/:id', label: 'Edit Anggaran Aktivitas', component: Components.EditBudgetActivityDetails },
          { path: '/anggaran/kegiatan/lihat', label: 'Rincian Anggaran Aktivitas', component: Components.ViewBudgetActivity },
        ]
      },
      {
        key: 'fund_requests',
        label: 'Permohonan Dana',
        path: '/anggaran/permohonan-dana',
        permissions: ['fund_requests.view'],
        component: Components.FundRequests
      },
    ],
  },
  {
    key: 'bookkeeping',
    label: 'Pembukuan',
    icon: 'menu_book',
    children: [
      {
        key: 'starting_balance',
        label: 'Saldo Awal',
        path: '/pembukuan/saldo-awal',
        permissions: ['manage_opening_balance'],
        component: Components.StartingBalance
      },
      {
        key: 'migration',
        label: 'Migrasi',
        path: '/pembukuan/migrasi',
        permissions: ['manage_data_migration'],
        component: Components.Migration,
        subRoutes: [
          { path: '/pembukuan/migrasi/lihat', label: 'Rincian Data Migrasi', component: Components.ViewMigration },
          { path: '/pembukuan/migrasi/edit', label: 'Edit Data Migrasi', component: Components.EditMigration },
          { path: '/pembukuan/migrasi/unggah', label: 'Unggah Data Migrasi', component: Components.UploadMigration },
        ]
      },
      {
        key: 'general_ledger',
        label: 'Jurnal Umum',
        path: '/pembukuan/jurnal-umum',
        permissions: ['manage_general_ledger'],
        component: Components.Ledger,
        subRoutes: [
          { path: '/pembukuan/jurnal-umum/lihat', label: 'Rincian Jurnal Umum', component: Components.ViewLedger },
          { path: '/pembukuan/jurnal-umum/tambah', label: 'Buat Jurnal Umum', component: Components.AddLedger },
          { path: '/pembukuan/jurnal-umum/edit', label: 'Edit Jurnal Umum', component: Components.EditLedger },
        ]
      },
      {
        key: 'expense',
        label: 'Pengeluaran',
        path: '/pembukuan/pengeluaran',
        permissions: ['manage_outflow_journal'],
        component: Components.Expense,
        subRoutes: [
          { path: '/pembukuan/pengeluaran/lihat', label: 'Rincian Pengeluaran', component: Components.ViewExpense },
          { path: '/pembukuan/pengeluaran/tambah', label: 'Buat Pengeluaran', component: Components.AddExpense },
          { path: '/pembukuan/pengeluaran/edit', label: 'Edit Pengeluaran', component: Components.EditExpense },
        ]
      },
      {
        key: 'revenue',
        label: 'Pendapatan',
        path: '/pembukuan/Pendapatan',
        permissions: ['manage_revenue_journal'],
        component: Components.Revenue,
        subRoutes: [
          { path: '/pembukuan/pendapatan/lihat', label: 'Rincian Pendapatan', component: Components.ViewRevenue },
          { path: '/pembukuan/pendapatan/tambah', label: 'Buat Pendapatan', component: Components.AddRevenue },
          { path: '/pembukuan/pendapatan/edit', label: 'Edit Pendapatan', component: Components.EditRevenue },
        ]
      },
      {
        key: 'closing_cycle',
        label: 'Tutup Buku',
        path: '/pembukuan/tutup-buku',
        permissions: ['manage_financial_close'],
        component: Components.ClosingCycle
      },
      {
        key: 'cg_journal',
        label: 'Jurnal CG',
        path: '/pembukuan/jurnal-cg',
        permissions: ['manage_cekgudang_bookkeeping'],
        component: Components.LedgerCG,
        subRoutes: [
          {
            path: '/pembukuan/jurnal-cg/edit',
            label: 'Ubah Jurnal CG',
            component: () => React.createElement(Components.LedgerCGForm, { type: "edit" })
          },
          {
            path: '/pembukuan/jurnal-cg/view',
            label: 'Rincian Jurnal CG',
            component: () => React.createElement(Components.LedgerCGForm, { type: "view" })
          },
        ]
      },
    ],
  },
  {
    key: 'reports',
    label: 'Laporan',
    icon: 'analytics',
    path: '/laporan',
    permissions: ['manage_reports'],
    children: [
      {
        key: 'ledger_report',
        label: 'Buku Besar',
        path: '/laporan/buku-besar',
        component: Components.ReportLedger,
        permissions: ['manage_ledger_reports'],

      },
      {
        key: 'profit_loss_report',
        label: 'Laba Rugi',
        path: '/laporan/laba-rugi',
        component: Components.ReportProfitLoss,
        permissions: ['manage_profit_loss_report'],

      },
      {
        key: 'balance_sheet_report',
        label: 'Neraca Keuangan',
        path: '/laporan/neraca-keuangan',
        component: Components.ReportBalanceSheet,
        permissions: ['manage_balance_sheet_report'],
      },
      {
        key: 'cash_flow_report',
        label: 'Arus Kas',
        path: '/laporan/arus-kas',
        component: Components.ReportCashFlow,
        permissions: ['manage_cash_flow_report'],
      },
    ],
  },
  {
    key: 'settings',
    label: 'Pengaturan',
    icon: 'settings',
    permissions: ['manage_settings'],
    children: [
      {
        key: 'activities',
        label: 'Aktivitas',
        path: '/pengaturan/aktivitas',
        permissions: ['view_activities'],
        component: Components.Activities
      },
      {
        key: 'activity_categories',
        label: 'Kategori Aktivitas',
        path: '/pengaturan/kategori-aktivitas',
        permissions: ['manage_activity_categories'],
        component: Components.ActivityCategories
      },
      {
        key: 'budget_posts',
        label: 'Pos Anggaran',
        path: '/pengaturan/pos-anggaran',
        permissions: ['manage_budget_posts'],
        component: Components.BudgetPosts
      },
      {
        key: 'coa_categories',
        label: 'Kategori COA',
        path: '/pengaturan/kategori-coa',
        permissions: ['manage_coa_categories'],
        component: Components.CoaCategory
      },
      {
        key: 'coa',
        label: 'Daftar COA',
        path: '/pengaturan/coa',
        permissions: ['manage_coa'],
        component: Components.CoaPage,
        subRoutes: [
          { path: '/pengaturan/coa/tambah', label: 'Tambah Akun', component: Components.CreateCoaPage },
          { path: '/pengaturan/coa/edit', label: 'Edit Akun', component: Components.EditCoaPage },
          { path: '/pengaturan/coa/upload', label: 'Upload Coa', component: Components.UploadCoaPage },
          { path: '/pengaturan/coa/download', label: 'Export Coa', component: Components.DownloadCoaPage },
        ]
      },
      {
        key: 'workflow',
        label: 'Workflow',
        path: '/pengaturan/workflow',
        permissions: ['manage_workflow'],
        component: Components.WorkflowsPage,
        subRoutes: [
          { path: '/pengaturan/workflow/edit/:id', label: 'Edit Workflow', component: Components.EditWorkflow },
        ]
      },
      {
        key: 'journal_settings',
        label: 'Nomor Jurnal',
        path: '/pengaturan/nomor-jurnal',
        permissions: ['manage_journal_number_settings'],
        component: Components.SettingJournalNumber
      },
      {
        key: 'profit_loss_settings',
        label: 'Laba Rugi',
        path: '/pengaturan/laba-rugi',
        permissions: ['manage_profit_loss_settings'],
        component: Components.SettinigProfitLoss
      },
      {
        key: 'net_profit_loss_settings',
        label: 'Laba/Rugi Bersih',
        path: '/pengaturan/laba-rugi-bersih',
        permissions: ['manage_nett_profit_loss_settings'],
        component: Components.SettingNetProfitLoss
      },
      {
        key: 'balance_sheet_settings',
        label: 'Neraca Keuangan',
        path: '/pengaturan/neraca-keuangan',
        permissions: ['manage_balance_sheet_settings'],
        component: Components.SettingBalanceSheet
      },
      {
        key: 'cash_flow_settings',
        label: 'Arus Kas',
        path: '/pengaturan/arus-kas',
        permissions: ['manage_cash_flow_settings'],
        component: Components.SettingCashFlow
      },
      {
        key: 'filter_account_settings',
        label: 'Filter Akun',
        path: '/pengaturan/filter-akun',
        permissions: ['manage_filter_account_settings'],
        component: Components.SettingFilterAccount
      },
      {
        key: 'budget_settings',
        label: 'Anggaran',
        path: '/pengaturan/anggaran',
        permissions: ['manage_budget_settings'],
        component: Components.SettingBudgeting
      },
      {
        key: 'budget_number_settings',
        label: 'Nomor Anggaran',
        path: '/pengaturan/nomor-anggaran',
        permissions: ['manage_budget_number_settings'],
        component: Components.SettingBudgetNumber
      },
    ],
  },
];

// Function to generate flat route list from MENU_STRUCTURE
export const generateRouteList = () => {
  const routes = [];

  const processMenuItem = (item) => {
    // Add main route if it has a component
    if (item.component) {
      routes.push({
        path: item.path,
        label: item.label,
        element: item.component,
      });
    }

    // Add parent routes if specified
    if (item.routes) {
      item.routes.forEach(route => {
        routes.push({
          path: route.path,
          label: route.label,
          element: route.component,
        });
      });
    }

    // Add sub-routes
    if (item.subRoutes) {
      item.subRoutes.forEach(subRoute => {
        routes.push({
          path: subRoute.path,
          label: subRoute.label,
          element: subRoute.component,
        });
      });
    }

    // Process children recursively
    if (item.children) {
      item.children.forEach(child => processMenuItem(child));
    }
  };

  MENU_STRUCTURE.forEach(processMenuItem);
  return routes;
};
